import api from './api';

export const bulkService = {
  createBulkRedirect: (brandId, domainIds, targetUrl) => 
    api.post('/bulk/redirect', {
      brandId,
      domain_ids: domainIds,
      target_url: targetUrl,
    }),
  
  getOperationStatus: (operationId) => 
    api.get(`/bulk/operation/${operationId}`),
  
  getOperations: (brandId) => 
    api.get(`/bulk/operations/${brandId}`),
};
